var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-ebook-home"},[_c('ebook-header'),_c('div',{staticClass:"container-fluid pt-5"},[(_vm.hasEbook)?_c('ebook-section'):(!_vm.filesLoading)?_c('ebook-empty-state'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }